import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[markScrolled]',
    standalone: false
})
export class MarkScrolledDirective {
  // The element on which to add a class when host is scrolled
  @Input('markScrolled') TARGET;

  // The class to be added
  className: string = '--scrolled';

  // trigger position
  triggerPosition: number = 10;

  constructor(private el: ElementRef) {}

  @HostListener('scroll', ['$event']) onScroll(ev) {
    let pos = ev.target.scrollTop;
    if (pos > this.triggerPosition) {
      this.TARGET.classList.add(this.className);
    } else {
      this.TARGET.classList.remove(this.className);
    }
  }
}
